export enum DistanceUnit {
  NAUTICAL_MILE = 1,
  KILOMETER = 2,
}

export const DEFAULT_DISTANCE_UNIT = DistanceUnit.NAUTICAL_MILE;

